export default function objectToUrlSearchParams(
    obj: Record<string, string>,
): string {
    return new URLSearchParams(obj).toString();
}
